import React, { useEffect, useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import {
  fetchAdminData,
  fetchGraphicalInformation,
  fetchInstructorData,
  fetchLearnerData,
  setCount,
} from 'store/units';
import Router from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import AutoCompleteRender from './newHeaderSearch';
import CmsProfileAvatar from './ProfileAvatar';
import { useUser } from '../../../hooks';
import classnames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import CmsMenu from './newMenu';
import styles from 'styles/Layout.module.scss';
import { handleToastError } from 'helpers';
import userApi from 'api/userApi';
import * as Icon from 'react-feather';
import {
  getCartCountAsync,
  getWishListAsync,
  getPaymentPage,
} from 'store/cart';
import { setHeaderTextSearch } from 'store/search';
import scheduleApi from 'api/scheduleApi';
import moment from 'moment';
import { SELECTED_CENTRES, USER_TOKEN, USER_VIEW_MODE } from 'helpers/storage';
import ModalSchedule from './ModalSchedule';
import HeaderLogo from './HeaderLogo';
import HeaderMenu from './HearderMenu';
import HeaderIcons from './HeaderIcons';
import Select from 'react-select';
import { Search } from 'react-feather';
import useI18n from 'hooks/use-i18n';
import {
  getCentresList,
  setSelectedCentre,
  getSelectedCentre,
  setCentresList,
} from 'store/master';
import styled from '@emotion/styled';
import { IoLocationOutline } from 'react-icons/io5';
import { MdClose } from 'react-icons/md';
import {
  setGlobalDateFilter,
  setClassesDateFilter,
  setLiveClassesDateFilter,
  setTestandAssignmentDateFilter,
  setTrafficDateFilter,
  setGlobalDateFilterInstructor,
  setClassesDateFilterInstructor,
  setLiveClassesDateFilterInstructor,
  setTestandAssignmentDateFilterInstructor,
  setDashboardType,
} from 'store/global';
import useWindowSize from 'hooks/useWindowSize';
import { isIOS, isMobile } from 'react-device-detect';
import { getViewMode } from 'store/auth';
import { USER_ROLES } from 'constants/constants';
import NavProfile from './nav-profile';
import { deleteCookie } from 'cookies-next';
import useNProgress from 'hooks/use-nprogress';

function useForceUpdate() {
  //force render
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const forceUpdate = useForceUpdate();
  useNProgress();
  const [width, height] = useWindowSize();
  const dashboardDate = [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ];
  const toggle = () => {
    setOpen(false);
    setIsOpen(!isOpen);
  };
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const dispatch = useDispatch();
  const { query, pathname } = useRouter();
  const router = useRouter();
  const user = useUser();
  const i18n = useI18n();
  const [schedule, setSchedule] = useState();
  const viewMode = useSelector(getViewMode);
  const selectedCentre = useSelector(getSelectedCentre);
  const centreList = useSelector(getCentresList);
  const paymentPageStatus = useSelector(getPaymentPage);
  const [open, setOpen] = useState(false);
  const { asPath } = useRouter();
  const [searchText, setSearchText] = useState('');
  const [isSearch, setIsSearch] = useState(false);
  const Stylescal = styled.div`
    & {
      width: ${width >= 660 ? '100%' : '260px'};
    }
    .centre-location-select .css-1pahdxg-control:hover {
      border-color: var(--theme-clr) !important;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    & > div > .centre-location-select > div:first-of-type > :first-child > div {
      color: var(--select-control-text-clr);
    }
    & > div > .centre-location-select > div:first-of-type > :last-child > span {
      background-color: transparent;
    }
    & > div > .centre-location-select > div:first-of-type > :last-child > div {
      color: var(--select-control-text-clr);
    }
  `;

  const shouldHideLoginButton = Router.pathname === '/loginCms';
  const shouldHideSignupButton = Router.pathname === '/homes/signup';
  useEffect(() => {
    if (
      !(
        asPath.includes(user?._id ? '/lms-user/home' : '/homeCms') ||
        asPath.includes(user?._id ? '/course' : '/homes/course') ||
        asPath.includes('/intakes/intake-grid') ||
        asPath.includes('/homes/myLearning') ||
        asPath.includes('/homes/intake') ||
        asPath.includes('/unit') ||
        asPath.includes('/reports')
      )
    ) {
      sessionStorage.removeItem('breadCrumb');
      let array = [
        {
          text: 'Dashboard',
          link: '/',
          customLink: '/',
          val: 'dashboard',
        },
      ];
      sessionStorage.setItem('breadCrumb', JSON.stringify(array));
    }
  }, [asPath]);

  useEffect(async () => {
    if (!user?._id && USER_TOKEN.get()) {
      deleteCookie('userViewMode', { path: '/' });
      deleteCookie('userToken', { path: '/' });
      await USER_TOKEN.delete();
      await USER_VIEW_MODE.delete();
    }
  }, []);

  useEffect(() => {
    if (pathname !== '/course/[slug]/unit/[unitId]') {
      sessionStorage.removeItem('shuffledArrayQuiz');
    }
  }, [pathname]);

  useEffect(() => {
    if (query?.email && query?.iframe && query?.usertype == 'learner') {
      setInterval(async () => {
        if (query?.email) {
          const res = await userApi.getUserByMail(query?.email);
          Router.push(
            `${res?.monitoringUrl}?iframe=true&email=${query?.email}&usertype=learner`,
          );
        }
      }, 5000);
    }
  }, [query?.iframe]);

  // logo click
  const homeClick = async () => {
    setIsOpen(false);
    if (user?._id) {
      const formData = new FormData();
      let dataForm = {
        firstName: user?.firstName,
        lastName: user?.lastName,
        bio: user?.bio ? user?.bio : '',
        language: user.language,
        twoFA: user.twoFA,
        mobile: user?.mobile,
        Mobilephoneno: user?.mobile?.slice(3, 13),
        mainPage: user?.mainPage ? user?.mainPage : null,
        monitoringUrl: `/lms-user/home`,
        dirtyFields: ['monitoringUrl'],
        // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      formData.append('data', JSON.stringify(dataForm));
      await userApi.updateUserById(user?._id, formData);
      await Router.push('/lms-user/home');
    } else {
      await Router.push('/homeCms');
    }

    dispatch(setHeaderTextSearch(''));
  };

  const courseClick = () => {
    Router.push(
      `${
        user?._id
          ? metaData?.cmsHomePage
            ? '/course'
            : '/intakes/intake-grid'
          : metaData?.cmsHomePage
          ? '/homes/course'
          : '/intakes/intake-grid'
      }`,
    );
    setIsOpen(false);
    forceUpdate();
    dispatch(setHeaderTextSearch(''));
  };
  const centreDashboard = () => {
    const url =
      router.query?.dashboard === 'onboarding' ? '/?dashboard=onboarding' : '/';
    router.push(url);
  };
  const onboardDashboard = (type) => {
    router.push('/');
    setIsOpen(false);
    dispatch(setDashboardType(type));
    dispatch(setHeaderTextSearch(''));
  };
  const dashboardClick = () => {
    Router.push('/');
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };

  const chatClick = () => {
    Router.push(`${user?._id ? '/messages' : '/login'}`);
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };
  const wishlistClick = () => {
    Router.push(
      `${user?._id ? '/lms-user/cart/wishList' : '/homes/cart/wishList'}`,
    );
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };
  const cartClick = () => {
    Router.push(`${user?._id ? '/lms-user/cart' : '/homes/cart'}`);
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };
  const menuClick = () => {
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };
  const companyClick = () => {
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };
  const profileClick = () => {
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };
  const mylearningClick = () => {
    Router.push('/homes/myLearning');
    setIsOpen(false);
    dispatch(setHeaderTextSearch(''));
  };
  const loginClick = () => {
    if (metaData?.cmsHomePage == true) {
      Router.push('/loginCms');
    } else {
      Router.push('/login');
    }
    dispatch(setHeaderTextSearch(''));
  };
  const signupClick = () => {
    Router.push('/homes/signup');
    dispatch(setHeaderTextSearch(''));
  };
  const onFooterClick = async (footerType) => {
    setIsOpen(false);
    switch (footerType) {
      case 'aboutUs-type':
        let aboutUs = { type: 'aboutUs' };
        Router.push({
          pathname: user?._id ? '/lms-user/footer' : '/homes/footer/aboutus',
          query: aboutUs,
        });
        break;
      case 'contactUs-type':
        let contactUs = { type: 'contactUs' };
        Router.push({
          pathname: user?._id ? '/lms-user/footer' : '/homes/footer/contactus',
          query: contactUs,
        });
        break;
    }

    forceUpdate();
    dispatch(setHeaderTextSearch(''));
  };

  // async function getAdminSummaries() {
  //   try {
  //     const response = await userApi.getAdminSummary();
  //     dispatch(setCount(response));
  //     dispatch(fetchAdminData());
  //   } catch (error) {
  //     handleToastError(error);
  //   }
  // }

  // const workshopHandler = async (id) => {
  //   if (id) {
  //     const formData = new FormData();
  //     let dataForm = {
  //       firstName: user?.firstName,
  //       lastName: user?.lastName,
  //       bio: user?.bio ? user?.bio : '',
  //       language: user.language,
  //       twoFA: user.twoFA,
  //       mobile: user?.mobile,
  //       Mobilephoneno: user?.mobile?.slice(3, 13),
  //       mainPage: user?.mainPage ? user?.mainPage : null,
  //       monitoringUrl: `/workshop/workshopCard`,
  //       timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  //     };
  //     formData.append('data', JSON.stringify(dataForm));
  //     await userApi.updateUserById(user?._id, formData);
  //     await Router.push('/workshop/workshopCard');
  //   } else {
  //     await Router.push('/homes/workshop');
  //   }
  //   dispatch(fetchInstructorData());
  // };

  // async function getInstructorSummaries() {
  //   try {
  //     const response = await userApi.getInstructorSummary();
  //     dispatch(fetchInstructorData());
  //   } catch (error) {
  //     handleToastError(error);
  //   }
  // }

  // async function getLearnerSummaries() {
  //   try {
  //     const response = await userApi.getLearnerSummary();
  //     dispatch(fetchGraphicalInformation(user._id));
  //     dispatch(fetchLearnerData());
  //   } catch (error) {
  //     handleToastError(error);
  //   }
  // }

  async function getSchedule() {
    try {
      var start = moment().startOf('day'); // set to 12:00 am today
      var end = moment().endOf('day'); // set to 23:59 pm today
      let formData = {
        begin: start.toISOString(),
        end: end.toISOString(),
      };
      const response = await scheduleApi.todaySchedule(formData);
      setSchedule(response.data);
    } catch (e) {
      handleToastError(e);
    }
  }

  useEffect(async () => {
    if (user?._id) {
      // getAdminSummaries();
      // getInstructorSummaries();
      // getLearnerSummaries();
      (viewMode === USER_ROLES.ADMIN ||
        viewMode === USER_ROLES.SUPER_ADMIN ||
        viewMode === USER_ROLES.INSTRUCTOR) &&
        getSchedule();
    }
    if (metaData?.cmsHomePage) {
      !paymentPageStatus && dispatch(getCartCountAsync(user?._id));
      !paymentPageStatus && dispatch(getWishListAsync(user?._id));
    }
  }, [user?._id, metaData?.cmsHomePage]);

  const [previewModal, setPreiewModal] = useState(false);
  const previewHandler = () => {
    setPreiewModal(true);
    dispatch(setHeaderTextSearch(''));
  };

  const dateConvert = (dates) => {
    let dateTimeString = dates.split('');
    let ans =
      dateTimeString[8] +
      dateTimeString[9] +
      '-' +
      dateTimeString[5] +
      dateTimeString[6] +
      '-' +
      dateTimeString[0] +
      dateTimeString[1] +
      dateTimeString[2] +
      dateTimeString[3];
    return ans;
  };

  const viewHandler = async (data) => {
    setPreiewModal(false);
    Router.push({
      pathname:
        viewMode === USER_ROLES.INSTRUCTOR
          ? `/timesheet/myschedule/view`
          : `/timesheet/schedule/view`,

      query: { id: data._id },
    });
  };

  const handleCentresChange = async (vl) => {
    try {
      if (vl.name === 'All Centre') {
        dispatch(setSelectedCentre(undefined));
        await SELECTED_CENTRES.delete();
      } else {
        dispatch(setSelectedCentre(vl));
        const value = JSON.stringify(vl);
        await SELECTED_CENTRES.set(value);
      }
      dispatch(setTrafficDateFilter(dashboardDate));
      dispatch(setLiveClassesDateFilter(dashboardDate));
      dispatch(setTestandAssignmentDateFilter(dashboardDate));
      dispatch(setClassesDateFilter(dashboardDate));
      dispatch(setGlobalDateFilter(dashboardDate));
      dispatch(setLiveClassesDateFilterInstructor(dashboardDate));
      dispatch(setTestandAssignmentDateFilterInstructor(dashboardDate));
      dispatch(setClassesDateFilterInstructor(dashboardDate));
      dispatch(setGlobalDateFilterInstructor(dashboardDate));
    } catch (e) {
      handleToastError(e);
    }
  };

  return (
    <>
      <ModalSchedule
        previewModal={previewModal}
        setPreiewModal={setPreiewModal}
        schedule={schedule}
        dateConvert={dateConvert}
        viewHandler={viewHandler}
      />
      <div className="header-autocml-cms header-standard header-location">
        <header id="mainscms" className="headercms">
          <div className="container-xl px-0">
            <div className={classnames('cardshade', styles['cardshade'])}>
              <Navbar
                light
                expand="lg"
                style={{ gap: '.5rem' }}
                className={`fixtop header-height dynamic-gap-v bg-white  header-shadow ${
                  !user?._id ? 'justify-content-between' : null
                }`}
              >
                <div className="headercms-logo">
                  <HeaderLogo selectedCentre={selectedCentre} />
                </div>

                {!user?._id && (
                  <>
                    {' '}
                    <div className="header__nav-link chat-icon-mobile log-sign-btn">
                      {!shouldHideLoginButton ? (
                        <button
                          className="login-mob-res btn btn-sm dynamic-btn-clr"
                          onClick={loginClick}
                        >
                          Login
                        </button>
                      ) : null}
                      {!shouldHideSignupButton ? (
                        <button
                          className="btn btn-sm signup-mob-res ml-1 mr-1 dynamic-btn-clr"
                          onClick={signupClick}
                        >
                          Sign Up
                        </button>
                      ) : null}
                    </div>
                  </>
                )}
                {user?._id && width >= 660 && (
                  <div
                    className={`d-flex align-items-center justify-content-end flex-1
                        search-left`}
                  >
                    <>
                      {isSearch ? (
                        <AutoCompleteRender className="w-100" />
                      ) : (
                        <Stylescal>
                          <div className="header-centre-menu d-flex align-items-end ">
                            <button className="btn h-100 d-flex justify-content-center align-items-center">
                              <IoLocationOutline
                                size={20}
                                color="var(--text-background-clr)"
                              />
                            </button>

                            <Select
                              className="centre-location-select flex-1"
                              options={[
                                { name: 'All Centre', _id: 'All Centre' },
                                ...centreList,
                              ]}
                              defaultValue={selectedCentre}
                              isLoading={!centreList?.length}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option._id}
                              onChange={(e) => {
                                handleCentresChange(e);
                                centreDashboard();
                              }}
                              placeholder={
                                searchText === 'All Centre'
                                  ? 'Search ...'
                                  : 'All Centre'
                              }
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderBottomLeftRadius: '0px',
                                  borderTopLeftRadius: '0px',

                                  boxShadow: 'none',
                                  borderColor: 'transparent',
                                  backgroundColor: 'transparent',
                                  ...(isMobile && isIOS
                                    ? { fontSize: 16 }
                                    : {}),
                                  padding: '0 15px 0 35px',
                                  ':hover': {
                                    borderColor: `transparent`,
                                  },
                                  ':foucs': {
                                    borderColor: `transparent`,
                                  },
                                }),
                              }}
                            />
                          </div>
                        </Stylescal>
                      )}
                    </>
                    <span
                      onClick={() => setIsSearch(!isSearch)}
                      className="mr-lg-1 ml-1 header-Learning"
                    >
                      {!isSearch ? <Search size={23} /> : <MdClose size={23} />}
                    </span>
                  </div>
                )}
                {user?._id && (
                  <div
                    style={{ ...(width <= 660 && { order: -1 }) }}
                    className="chat-icon-mobile explore-menu-conatainer"
                  >
                    <CmsMenu setOpen={setOpen} />
                  </div>
                )}
                <NavbarToggler onClick={toggle} />
                <Collapse
                  isOpen={isOpen && open == false}
                  navbar
                  className="header-navbar-collapse"
                >
                  {' '}
                  {user?._id && (
                    <div className="chat-icon-mobile  w-100 mb-1">
                      {/* <CmsProfileAvatar />  */}
                      <NavProfile />
                    </div>
                  )}
                  {/* {!user?._id && (
                    <div className="col search-left d-flex align-items-center justify-content-center">
                      <div>
                        <AutoCompleteRender className="w-100 ml-lg-1 mt-1 mt-lg-0" />
                      </div>
                    </div>
                  )} */}
                  {user?._id && width <= 660 && (
                    <>
                      <hr />
                      <div
                        className={`d-flex align-items-center justify-content-md-end justify-content-center flex-1
                        search-left`}
                      >
                        <>
                          {isSearch ? (
                            <AutoCompleteRender className="w-100" />
                          ) : (
                            <Stylescal>
                              <div className="header-centre-menu d-flex align-items-end ">
                                <button className="btn dynamic-btn-clr h-100 d-flex justify-content-center align-items-center">
                                  <IoLocationOutline
                                    size={20}
                                    color={'var(--text-background-clr)'}
                                  />
                                </button>

                                <Select
                                  className="centre-location-select flex-1"
                                  options={[
                                    { name: 'All Centre', _id: 'All Centre' },
                                    ...centreList,
                                  ]}
                                  defaultValue={selectedCentre}
                                  isLoading={!centreList?.length}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option._id}
                                  onChange={(e) => {
                                    handleCentresChange(e);
                                    Router.push(
                                      router?.query?.dashboard === 'onboarding'
                                        ? '/?dashboard=onboarding'
                                        : '/',
                                    );
                                  }}
                                  placeholder={
                                    searchText === 'All Centre'
                                      ? 'Search ...'
                                      : 'All Centre'
                                  }
                                  // onFocus={() => {
                                  //   setSearchText('status');
                                  // }}
                                  // onBlur={() => {
                                  //   setSearchText('');
                                  // }}
                                  styles={{
                                    control: (provided, state) => ({
                                      ...provided,
                                      borderBottomLeftRadius: '0px',
                                      borderTopLeftRadius: '0px',
                                      boxShadow: 'none',
                                      borderColor: 'transparent',
                                      backgroundColor: 'transparent',
                                      padding: '0 15px 0 35px',
                                      ...(isMobile && isIOS
                                        ? { fontSize: 16 }
                                        : {}),
                                      ':hover': {
                                        borderColor: `transparent`,
                                      },
                                      ':foucs': {
                                        borderColor: `transparent`,
                                      },
                                    }),
                                  }}
                                />
                              </div>
                            </Stylescal>
                          )}
                        </>
                        <span
                          onClick={() => setIsSearch(!isSearch)}
                          className="mr-lg-1 ml-1 header-Learning"
                        >
                          {!isSearch ? (
                            <Search size={23} />
                          ) : (
                            <MdClose size={23} />
                          )}
                        </span>
                      </div>
                      <hr />
                    </>
                  )}
                  <HeaderMenu
                    homeClick={homeClick}
                    onboardDashboard={onboardDashboard}
                    dashboardClick={dashboardClick}
                    previewHandler={previewHandler}
                    courseClick={courseClick}
                    companyClick={companyClick}
                    mylearningClick={mylearningClick}
                  />
                  {user?._id && (
                    <div
                      className="header__nav-link d-none d-sm-block drop-menu"
                      onClick={menuClick}
                    >
                      <CmsMenu setOpen={setOpen} />
                    </div>
                  )}
                  <HeaderIcons
                    chatClick={chatClick}
                    wishlistClick={wishlistClick}
                    cartClick={cartClick}
                  />
                  {!user?._id && (
                    <>
                      {!shouldHideLoginButton ? (
                        <div className="header__nav-link chat-icon-res">
                          <button
                            className="btn  btn-sm dynamic-btn-clr"
                            onClick={loginClick}
                          >
                            Login
                          </button>
                        </div>
                      ) : null}
                      {!shouldHideSignupButton ? (
                        <div className="header__nav-link chat-icon-res">
                          <button
                            className="btn  btn-sm dynamic-btn-clr"
                            onClick={signupClick}
                          >
                            Sign Up
                          </button>
                        </div>
                      ) : null}
                    </>
                  )}
                  {/* {user?._id && (
                    <div className="chat-icon-res" onClick={profileClick}>
                      <CmsProfileAvatar />{' '}
                    </div>
                  )} */}
                  {user?._id && (
                    <div className="chat-icon-res header__nav-link">
                      <NavProfile />
                    </div>
                  )}
                </Collapse>
              </Navbar>
            </div>
          </div>
        </header>
        <div id="header-progress"></div>
      </div>
    </>
  );
};
export default Header;
